import hash from 'hash-sum';

// eslint-disable-next-line @typescript-eslint/ban-types
export const generateKeyForElement = (...obj: object[]): string => {
  return hash(obj);
};
